import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly stubLayers: ReadonlyArray<{ readonly __typename?: 'StubLayer', readonly layerId: Types.StubLayerId, readonly totalVotes: number, readonly hasVoted: boolean }>, readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string, readonly digitalCastSettings?: Record<string, any> | null, readonly funnelSettings: { readonly __typename?: 'YalperFunnelSettings', readonly goals: ReadonlyArray<{ readonly __typename?: 'YalperFunnelGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> }, readonly funnelGoalStats: ReadonlyArray<{ readonly __typename?: 'YalperFunnelGoalStat', readonly goalId: number, readonly date: string, readonly conversions: number }>, readonly graphStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly date: string, readonly spent: number, readonly clicks: number, readonly impressions: number, readonly extendedPlatform: Types.YalperExtendedPlatform }>, readonly graphSensorChecks: ReadonlyArray<{ readonly __typename?: 'YalperGraphSensorCheck', readonly new: number, readonly old: number, readonly fixed: number, readonly collectedOn: string, readonly sensorGroup?: Types.YalperChecksSensorGroup | null, readonly sensorName: string }>, readonly mediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperMediaplanStat', readonly collectedOn: string, readonly avgVideoCompleteCost: number, readonly bounces: number, readonly comments: number, readonly conversions: number, readonly impressions: number, readonly likes: number, readonly reach: number, readonly revenue: number, readonly sessions: number, readonly shares: number, readonly spent: number, readonly videoCompleteRate: number, readonly videoComplete: number }>, readonly mediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly budget: number, readonly startOn: string, readonly endOn?: string | null, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly name: Types.AccountsKpiName, readonly value: string | number, readonly primary: boolean }> | null }> } | null, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null } } | null };

export type GetCurrentCompanyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentCompanyQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly uuid: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly lastError?: string | null, readonly provider: Types.OauthProvider, readonly isValid: boolean }> } | null } | null };

export type GetYandexLogsQueryVariables = Types.Exact<{
  timeFrom: Types.Scalars['String']['input'];
  timeTo: Types.Scalars['String']['input'];
  projectUuid: Types.Scalars['String']['input'];
}>;


export type GetYandexLogsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly yandexHistory?: ReadonlyArray<{ readonly __typename?: 'FlashpointYandexHistory', readonly time: string, readonly group: Types.FlashpointYandexChangeGroup } | null> | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($startDate: Date!, $endDate: Date!) {
  currentUser {
    stubLayers {
      layerId
      totalVotes
      hasVoted
    }
    currentCompany {
      id
      name
      funnelSettings {
        goals {
          id
          name
          counterId
          counterName
        }
      }
      funnelGoalStats(startDate: $startDate, endDate: $endDate) {
        goalId
        date
        conversions
      }
      graphStats(endDate: $endDate, startDate: $startDate) {
        date
        spent
        clicks
        impressions
        extendedPlatform
      }
      graphSensorChecks(startDate: $startDate, endDate: $endDate) {
        new
        old
        fixed
        collectedOn
        sensorGroup
        sensorName
      }
      mediaplanStats(endDate: $endDate, startDate: $startDate) {
        collectedOn
        avgVideoCompleteCost
        bounces
        comments
        conversions
        impressions
        likes
        reach
        revenue
        sessions
        shares
        spent
        videoCompleteRate
        videoComplete
      }
      mediaplans(endDate: $endDate, startDate: $startDate) {
        id
        budget
        startOn
        endOn
        repeat
        kpis {
          name
          value
          primary
        }
      }
      digitalCastSettings
    }
    subscription {
      planId
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetCurrentCompanyDocument = gql`
    query GetCurrentCompany {
  currentUser {
    currentCompany {
      uuid
      tokens {
        id
        lastError
        provider
        isValid
      }
    }
  }
}
    `;

/**
 * __useGetCurrentCompanyQuery__
 *
 * To run a query within a React component, call `useGetCurrentCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>(GetCurrentCompanyDocument, options);
      }
export function useGetCurrentCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>(GetCurrentCompanyDocument, options);
        }
export function useGetCurrentCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>(GetCurrentCompanyDocument, options);
        }
export type GetCurrentCompanyQueryHookResult = ReturnType<typeof useGetCurrentCompanyQuery>;
export type GetCurrentCompanyLazyQueryHookResult = ReturnType<typeof useGetCurrentCompanyLazyQuery>;
export type GetCurrentCompanySuspenseQueryHookResult = ReturnType<typeof useGetCurrentCompanySuspenseQuery>;
export type GetCurrentCompanyQueryResult = Apollo.QueryResult<GetCurrentCompanyQueryPage, GetCurrentCompanyQueryVariables>;
export const GetYandexLogsDocument = gql`
    query GetYandexLogs($timeFrom: String!, $timeTo: String!, $projectUuid: String!) {
  currentUser {
    yandexHistory(timeFrom: $timeFrom, timeTo: $timeTo, projectUuid: $projectUuid) {
      time
      group
    }
  }
}
    `;

/**
 * __useGetYandexLogsQuery__
 *
 * To run a query within a React component, call `useGetYandexLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYandexLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYandexLogsQuery({
 *   variables: {
 *      timeFrom: // value for 'timeFrom'
 *      timeTo: // value for 'timeTo'
 *      projectUuid: // value for 'projectUuid'
 *   },
 * });
 */
export function useGetYandexLogsQuery(baseOptions: Apollo.QueryHookOptions<GetYandexLogsQueryPage, GetYandexLogsQueryVariables> & ({ variables: GetYandexLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYandexLogsQueryPage, GetYandexLogsQueryVariables>(GetYandexLogsDocument, options);
      }
export function useGetYandexLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYandexLogsQueryPage, GetYandexLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYandexLogsQueryPage, GetYandexLogsQueryVariables>(GetYandexLogsDocument, options);
        }
export function useGetYandexLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetYandexLogsQueryPage, GetYandexLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYandexLogsQueryPage, GetYandexLogsQueryVariables>(GetYandexLogsDocument, options);
        }
export type GetYandexLogsQueryHookResult = ReturnType<typeof useGetYandexLogsQuery>;
export type GetYandexLogsLazyQueryHookResult = ReturnType<typeof useGetYandexLogsLazyQuery>;
export type GetYandexLogsSuspenseQueryHookResult = ReturnType<typeof useGetYandexLogsSuspenseQuery>;
export type GetYandexLogsQueryResult = Apollo.QueryResult<GetYandexLogsQueryPage, GetYandexLogsQueryVariables>;